<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ log_template.template_name }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-tooltip v-if="log_template.file_id != null">
                                <template slot="activator">
                                    <v-btn icon @click="expandImage()">
                                        <v-icon>image</v-icon>
                                    </v-btn>
                                </template>
                                View check point location
                            </bc-tooltip>
                            <bc-btn-add v-if="selected_capture_id || capture == null" @invoke-method="openComplete()"></bc-btn-add>
                            <!-- <bc-btn-refresh @invoke-method="dbGetCustomer(true)"></bc-btn-refresh>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobileList"></bc-btn-mobile-nav> -->
                        </v-toolbar>
                    </v-layout>
                </v-container>
                <v-container grid-list-xl>
                    <v-layout row :wrap="$bp.smallScreen">
                        <bc-search-list
                            v-if="capture_options.length > 0"
                            :items="capture_options"
                            :selected_id="selected_capture_id"
                            :filter="searchFilter"
                            :clickMethod="selectCaptureOption"
                            :item-value="capture == 'machines' ? 'machine_id' : 'part_id'"
                            :item-text="capture == 'machines' ? 'machine_name' : 'part_name'"
                            style="max-height: calc(100vh - 260px)"
                        ></bc-search-list>
                        <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen && capture_options.length > 0"></v-divider>
                        <v-flex
                            :class="capture_options.length > 0 ? 'xs12 md9 lg10' : 'lg12 md12 xs12'"
                            pa-0
                            :pl-3="capture_options.length > 0"
                            align-self-start
                        >
                            <v-card elevation="0" pa-0 style="max-width: 100% !important">
                                <v-card-text class="pa-0">
                                    <vue-perfect-scrollbar class="scroll-area" style="min-height: calc(100vh - 260px)">
                                        <h1 v-if="capture != null && logs.length > 0">
                                            {{ capture == "machines" ? logs[0].machine_name : logs[0].part_name }}
                                        </h1>
                                        <h1 v-if="logs.length == 0" style="text-align: center; color: lightgray">{{ logs_message }}</h1>
                                        <keep-alive v-else>
                                            <component :is="`${log_template.slug}_table`" :slug="log_template.slug" :logs="logs" :log_template="log_template">
                                            </component>
                                        </keep-alive>
                                    </vue-perfect-scrollbar>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
            <bc-dialog :value="complete_dialog" v-if="capture == null || (selected_capture_id && complete_dialog)" max-width="800">
                <v-card style="height: 100%">
                    <v-form ref="form_log">
                        <v-card-title>
                            <span class="headline">{{ $t("lang.add_log") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeLogDialog"
                                :dialog-status="complete_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text class="pa-2">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <template v-for="(q, i) in log_template.log_templates_detail">
                                        <v-flex xs12>
                                            <bc-question-field
                                                v-if="answers.length > 0"
                                                :key="i"
                                                v-model="answers.find((a) => a.detail_template_id == q.detail_template_id).user_value"
                                                :label="`${q.question}${q.required ? ' *' : ''}`"
                                                :type="$getElementType(q.element_type).value"
                                                :set-rules="q.element_rules"
                                                :set-items="q.options ? q.options.split(',') : null"
                                                :setup="complete_dialog"
                                                :hint="
                                                    $isSet(q.method) || $isSet(q.parameter)
                                                        ? `${q.method ? 'Method: ' + q.method : ''} // ${q.parameter ? 'Parameter: ' + q.parameter : ''}`
                                                        : ''
                                                "
                                                :persistent-hint="$isSet(q.method) || $isSet(q.parameter) ? true : false"
                                            >
                                            </bc-question-field>
                                        </v-flex>
                                    </template>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeLogDialog()">{{ $t("lang.cancel") }}</v-btn>

                            <v-btn color="success" @click="saveLogs()">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="image_dialog" style="width: fit-content">
                <v-card style="height: 100%">
                    <v-form ref="form_img">
                        <v-card-title>
                            <!-- <span class="headline">Check point location</span> -->
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeExpandImage"
                                :dialog-status="image_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text class="pa-2">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-img height="600" :contain="true" :src="log_template.image"></v-img>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeExpandImage()">{{ $t("lang.close") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

import hourly_operation_log_table from "Modules/manufacturing/logs/components/HourlyOperationLogTable.vue";
import furnace_check_sheet_table from "Modules/manufacturing/logs/components/FurnaceCheckSheetTable.vue";
import paint_process_check_sheet_table from "Modules/manufacturing/logs/components/PaintProcessCheckSheetTable.vue";
import honing_process_check_sheet_table from "Modules/manufacturing/logs/components/HoningProcessCheckSheetTable.vue";
import tempering_furnace_check_sheet_table from "Modules/manufacturing/logs/components/TemperingFurnaceCheckSheetTable.vue";
import vacuum_washer_check_list_table from "Modules/manufacturing/logs/components/VacuumWasherCheckListTable.vue";

export default {
    components: {
        hourly_operation_log_table,
        furnace_check_sheet_table,
        paint_process_check_sheet_table,
        honing_process_check_sheet_table,
        tempering_furnace_check_sheet_table,
        vacuum_washer_check_list_table,
    },
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openLogForm" },
                { title: this.$t("lang.refresh"), action: "dbGetLogs", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.log_id"), sortable: false, width: "7%" },
                { text: this.$t("lang.template_id"), sortable: false, width: "7%" },
                { text: this.$t("lang.slug"), sortable: false, width: "7%" },
                { text: this.$t("lang.frequency"), sortable: false, width: "7%" },
                { text: this.$t("lang.minutes"), sortable: false, width: "7%" },
                { text: this.$t("lang.capture"), sortable: false, width: "7%" },
                { text: this.$t("lang.machine_id"), sortable: false, width: "7%" },
                { text: this.$t("lang.part_id"), sortable: false, width: "7%" },
                { text: this.$t("lang.supervisor_id"), sortable: false, width: "7%" },
                { text: this.$t("lang.notes"), sortable: false, width: "7%" },
                { text: this.$t("lang.file_id"), sortable: false, width: "7%" },
                { text: this.$t("lang.version"), sortable: false, width: "7%" },
                { text: this.$t("lang.active"), sortable: false, width: "7%" },
            ],
            enableAddModal: true,
            enableEditModal: true,

            log: {},
            logs: [],
            log_template: {},
            filter: {
                search: "",
                status: "1",
            },
            log_dialog: false,
            dbGetLogs: _.debounce(this.getLogs, 1500, { maxWait: 1500, leading: true, trailing: false }),
            capture: null,
            capture_options: [],
            searchFilter: "",
            selected_capture_id: null,
            logs_message: "Please select a machine/part",
            complete_dialog: false,
            answers: [],
            image_dialog: false,
        };
    },
    beforeRouteEnter(to, from, next) {
        let path = to.path.split("/");
        store
            .dispatch("fetchLogTemplate", {
                id: path[path.length - 1],
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.log_templates) {
                    next((vm) => {
                        vm.resetLogs();
                        vm.log_template = { ...data.log_templates };
                        vm.capture = vm.log_template.capture;
                        vm.finishLoader();
                        vm.$store.commit("toggleMainMenu", false);

                        vm.refresh();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        this.$store.commit("toggleMainMenu", false);
        this.resetLogs();
        let path = to.path.split("/");
        store
            .dispatch("fetchLogTemplate", {
                id: path[path.length - 1],
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.log_templates) {
                    this.log_template = { ...data.log_templates };
                    this.capture = this.log_template.capture;
                    this.finishLoader();

                    this.refresh();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.logs.logs_filter,
            page: (state) => state.logs.page,
            rules_logs: (state) => state.logs.rules_logs,
            log_status_options: (state) => state.settings.log_status_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchLogs", "saveLog", "deleteLog"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openComplete() {
            this.complete_dialog = true;
            if (this.log_template && (this.log_template.log_templates_detail || []).length > 0) {
                this.answers = Array((this.log_template.log_templates_detail || []).length).fill("");
                // iterate through the log_template.log_templates_detail and add the detail_template_id, user_value, frequency, and minutes to the answers array
                for (let i = 0; i < this.log_template.log_templates_detail.length; i++) {
                    this.answers[i] = {
                        detail_template_id: this.log_template.log_templates_detail[i].detail_template_id,
                        user_value: "",
                        frequency: this.log_template.log_templates_detail[i].frequency,
                        minutes: this.log_template.log_templates_detail[i].minutes,
                    };
                }
            } else {
                this.answers = [];
            }

            this.log.template_id = this.log_template.template_id;
            this.log.slug = this.log_template.slug;
            this.log.frequency = this.log_template.frequency;
            this.log.minutes = this.log_template.minutes;
            this.log.capture = this.log_template.capture;
            this.log.active = this.log_template.active;
            this.log.version = this.log_template.version;
            if (this.capture == "machines") {
                this.log.machine_id = this.selected_capture_id;
            } else if (this.capture == "parts") {
                this.log.part_id = this.selected_capture_id;
            }
        },
        saveLogs() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_log")) {
                    let body = this.prepForm(this.log, this.rules_logs);
                    body.logs_detail = this.answers;
                    this.saveLog({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            this.refresh(false, true);
                            this.closeLogDialog();
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteLogs(id = null) {
            this.deleteLog({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getLogs();
                    this.closeLogDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeLogDialog() {
            this.log_dialog = false;
            this.complete_dialog = false;
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getLogs(pg_refresh = false) {
            this.startLoader();

            this.fetchLogs({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.log_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        selectCaptureOption(item) {
            if (this.capture == "machines") {
                this.selected_capture_id = item.machine_id;
            } else if (this.capture == "parts") {
                this.selected_capture_id = item.part_id;
            }

            this.logs_message = "Loading Logs...";
            let body = { with_details: 1 };
            body.slug = this.log_template.slug;
            if (this.capture == "machines") {
                body.machine_id = this.selected_capture_id;
            } else if (this.capture == "parts") {
                body.part_id = this.selected_capture_id;
            }

            this.fetchLogs({
                body: body,
            }).then((data) => {
                if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                if (typeof data !== "undefined" && data.logs) {
                    this.logs = data.logs;
                    if (this.logs.length == 0) {
                        this.logs_message = "No logs found for this machine/part";
                    }
                }
            });
        },
        refresh(force = false, getLogs = false) {
            if (this.capture != null) {
                if (this.capture == "machines") {
                    this.$store
                        .dispatch("fetchMachines", {
                            url: "machines",
                            method: "get",
                            body: {
                                slug: this.log_template.slug.includes("washer") ? "wash" : this.log_template.slug.includes("tempering") ? "temper" : "furnace",
                            },
                        })
                        .then((data) => {
                            if (typeof data === "undefined") this.$router.push({ name: "dashboard" });

                            if (typeof data !== "undefined" && data.machines) {
                                this.capture_options = data.machines;
                            }
                        });

                    if (getLogs == true) {
                        this.logs_message = "Loading Logs...";
                        let body = { with_details: 1 };
                        body.slug = this.log_template.slug;
                        body.machine_id = this.selected_capture_id;

                        this.fetchLogs({
                            body: body,
                        }).then((data) => {
                            if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                            if (typeof data !== "undefined" && data.logs) {
                                this.logs = data.logs;
                                if (this.logs.length == 0) {
                                    this.logs_message = "No logs found for this machine/part";
                                }
                            }
                        });
                    }
                } else if (this.capture == "parts") {
                    this.$store
                        .dispatch("fetchParts", {
                            url: "parts",
                            method: "get",
                            body: {},
                        })
                        .then((data) => {
                            if (typeof data === "undefined") this.$router.push({ name: "dashboard" });

                            if (typeof data !== "undefined" && data.parts) {
                                this.capture_options = data.parts;
                            }
                        });

                    if (getLogs) {
                        this.logs_message = "Loading Logs...";
                        let body = { with_details: 1 };
                        body.slug = this.log_template.slug;
                        body.part_id = this.selected_capture_id;
                        this.fetchLogs({
                            body: body,
                        }).then((data) => {
                            if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                            if (typeof data !== "undefined" && data.logs) {
                                this.logs = data.logs;
                                if (this.logs.length == 0) {
                                    this.logs_message = "No logs found for this machine/part";
                                }
                            }
                        });
                    }
                }
            } else {
                this.logs_message = "Please add a log to start one";
                let body = { with_details: 1 };
                body.slug = this.log_template.slug;

                this.fetchLogs({
                    body: body,
                }).then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    if (typeof data !== "undefined" && data.logs) {
                        this.logs = data.logs;
                        if (this.logs.length == 0) {
                            this.logs_message = "No logs found";
                        }
                    }
                });
            }
        },
        expandImage() {
            this.image_dialog = true;
        },
        closeExpandImage() {
            this.image_dialog = false;
        },
        resetLogs() {
            this.capture = null;
            this.capture_options = [];
            this.logs = [];
            this.log = {};
            this.answers = [];
            this.selected_capture_id = null;
            this.logs_message = "Please select a machine/part";
        },
    },
};
</script>
